
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("99rcJ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $3gadb = parcelRequire("3gadb");


var $8DN9t = parcelRequire("8DN9t");


var $9x2sR = parcelRequire("9x2sR");


var $1NBp8 = parcelRequire("1NBp8");


var $luv00 = parcelRequire("luv00");


var $g9Ghb = parcelRequire("g9Ghb");


var $2U9QW = parcelRequire("2U9QW");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1ytiN = parcelRequire("1ytiN");


var $dPJCf = parcelRequire("dPJCf");

const $544e89ef74bbdb03$export$5bc2ad8fe7e5e700 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    let t0;
    if ($[0] !== props || $[1] !== showTCNav) {
        t0 = showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($544e89ef74bbdb03$var$CalendarsLinkInner, props) : null;
        $[0] = props;
        $[1] = showTCNav;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    /**
   * showTCNav:
   * - Premium -> true, TC is a premium feature
   * - Standard -> true, iff user is Org/Site Admin, otherwise, false (https://hello.atlassian.net/wiki/spaces/CE2/pages/3031965072/ETC+Standard+P18N+Technical+Spec)
   * - Free -> true, TC upsell to all Free users (https://hello.atlassian.net/wiki/spaces/CE2/pages/2906634153/ETC+P18N+Technical+Spec)
   */ const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    return showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($544e89ef74bbdb03$var$CalendarsLinkInner, props) : null;
};
const $544e89ef74bbdb03$var$CalendarsLinkInner = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { onClick: onClick } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)($544e89ef74bbdb03$var$isOnSCalendarsRoute);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $544e89ef74bbdb03$var$i18n.calendarsTooltip);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== spaceKey) {
        t2 = (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        });
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: "",
            color: "currentColor"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Ghb.ReverseTrialLozengeListItemExperiment), {
            touchpointId: "confluence_reverse_trial_lozenges_tc_space_navigation",
            edition: (0, $euL71.ConfluenceEdition).PREMIUM
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $544e89ef74bbdb03$var$i18n.calendars);
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2U9QW.PremiumLozengeLoadable), null);
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    let t7;
    if ($[7] !== isSelected || $[8] !== onClick || $[9] !== ssrPlaceholderIdProp || $[10] !== t2) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: t2,
            onClick: onClick,
            elemBefore: t3,
            isSelected: isSelected,
            "data-vc": "team-calendar-navigation",
            elemAfter: t4,
            ...ssrPlaceholderIdProp
        }, t5, t6));
        $[7] = isSelected;
        $[8] = onClick;
        $[9] = ssrPlaceholderIdProp;
        $[10] = t2;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)($544e89ef74bbdb03$var$isOnSCalendarsRoute);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $544e89ef74bbdb03$var$i18n.calendarsTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
        href: (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        }),
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: "",
            color: "currentColor"
        }),
        isSelected: isSelected,
        "data-vc": "team-calendar-navigation",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Ghb.ReverseTrialLozengeListItemExperiment), {
            touchpointId: "confluence_reverse_trial_lozenges_tc_space_navigation",
            edition: (0, $euL71.ConfluenceEdition).PREMIUM
        }),
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $544e89ef74bbdb03$var$i18n.calendars), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2U9QW.PremiumLozengeLoadable), null)));
};
const $544e89ef74bbdb03$var$isOnSCalendarsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_CALENDARS).name || routeName === (0, $1NBp8.SPACE_CALENDARS_SUBCALENDAR).name
};
const $544e89ef74bbdb03$var$i18n = (0, $cgtv4.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    },
    calendars: {
        id: "side-navigation.space-navigation.calendars",
        defaultMessage: "Calendars"
    }
});
module.exports["CalendarsLink"] = $544e89ef74bbdb03$export$5bc2ad8fe7e5e700;

});

parcelRegister("2U9QW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ea97352de2ccf604$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "cJMmb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("nSyLX"))).PremiumLozenge
});
module.exports["PremiumLozengeLoadable"] = $ea97352de2ccf604$export$62673719cbe80cd0;

});

parcelRegister("nSyLX", function(module, exports) {

let $047c788bdeb73d49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $047c788bdeb73d49$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});


//# sourceMappingURL=CalendarsLink.0286e824.js.map
